import * as CryptoJS from 'crypto-js';
import {Spinner } from "react-bootstrap";
import {Cookies,axios,useState} from '../../../src/InBuildImports';
import {systemConfiguration,grades,GSystemConstants,Navigation,Endpoint,Properties, 
        ErrorConstants,ErrorFunction } from '../../../src/CommonImports';


export const encryptData = (key, value) => {
    return CryptoJS.AES.encrypt(value, key).toString();
};

export const decryptData = (key, value) => {
    try {
        if (value === null || value === undefined) {
            return null;
        }
        const decrypted = CryptoJS.AES.decrypt(value, key);
        
        if (decrypted) {
            const de_crypt = decrypted.toString(CryptoJS.enc.Utf8);
            return de_crypt ? de_crypt : value;
        } else {
            console.error(`${key} is not valid key for ${value}.`);
            return value;
        }
    } catch (e) {
        console.error(`Exception:: ${key}.`);
        return value
    }
}

export const getDecryptedValueByProperty=(property)=> {
    const isCookieEncryption = `${systemConfiguration.ENCRYPTION_COOCKIES_FLAG}`;
   
    if (isCookieEncryption==='true') {
        return decryptData(property,Cookies.get(property));
     }else{
        return Cookies.get(property);
     }
    
}


export const checkGLearnTechRecordInDB = async (prefix, value) => {
    try {
        const response = await axios.get(`${systemConfiguration.HOST}${Endpoint.CHECK_RECORD_IN_DB}${prefix}/${value}`);
        return response.data;
    } catch (error) {
        console.error(`Exception:: ${error}.`);
        return `Problem while checking record, Please try again later.`;
    }
};



export const isContainNumbers = (str) => {
    const regex = /\d/;
    if (regex.test(str)) {
        console.error('Numbers does not allow.');
        return `Numbers does not allow.`;
    }
    return ``;
}

export const isContainLetters = (str) => {
    const regex = /[a-zA-Z]/;
    if (regex.test(str)) {
        console.error('Letters are not allowed.');
        return 'Letters are not allowed.';
    }
    return '';
};

export const compareViews = (allowView, disallowView) => {
    const arr1 = new Set(allowView);
    const arr2 = new Set(disallowView);
    for (const item of arr2) {
        if (arr1.has(item)) {
            console.error('Duplicate Views allowcation!!!');
            return `Duplicate Views allowcation!!!`;
        }
    }
    return ``;
}

// export const isValidContactNumber = (number) => {
//     const regex = /^\d{10}$/;
//     if (number === null || number === undefined || number === ``)
//         return `Contact numbers is required.`;
//     else if (!regex.test(number))
//         return `Please enter Valid Contact Numbers.`;
//     else
//         return ``;
// }
export const isValidContactNumber = (value, fieldLabel) => {
    const regex = /^[0-9]{10}$/;
    if (!value) return `${fieldLabel} is required field.`;
    else if (!regex.test(value)) return `Please enter a valid ${fieldLabel}.`;
    else return '';
  };
  

// export const isValidEmail = (email) => {
//     const regex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
//     if (email === null || email === undefined || email === ``)
//         return `Email address is required.`;
//     else if (!regex.test(email))
//         return `Please enter a valid email address.`;
//     else
//         return ``;
// }
export const isValidEmail = (email, fieldLabel) => {
  const regex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
  if (!email) return `${fieldLabel} is required.`;
  else if (!regex.test(email)) return `Please enter a valid ${fieldLabel}.`;
  else return '';
};


export const isAnyStringEmpty = (...strings) => {
    const nonEmptyStrings = strings.filter(str => str.trim() !== '');
    if (nonEmptyStrings.length > 0) {
        throw new Error(`${nonEmptyStrings.join(', ')}`);
    } else { return ``; }
};

// export const isValidName = (name) => {
//     const regex = /^[a-zA-Z ]{2,30}$/;
//     if (name === null || name === undefined || name === ``)
//         return `Name is required`;
//     else if (!regex.test(name))
//         return `Please enter Valid Name.`;
//     else
//         return ``;
// }
export const isValidName = (name, fieldLabel) => {
    const regex = /^[a-zA-Z ]{2,50}$/;
    if (name === null || name === undefined || name === ``)
      return `${fieldLabel} is required field.`;
    else if (!regex.test(name))
      return `Please enter a valid ${fieldLabel}.`;
    else
      return '';
  };
  


export const isDateOld = (dateString) => {
    const inputDate = new Date(dateString);
    const today = new Date();
    const startOfToday = new Date(today.setHours(0, 0, 0, 0));
    const startOfInputDate = new Date(inputDate.setHours(0, 0, 0, 0));
    if (startOfInputDate.getTime() === startOfToday.getTime()) {
        return `It's today!`;
    } else if (startOfInputDate < startOfToday) {
        return `Date is earlier than today`;
    } else {
        return ``;
    }
};
export function clearCookies(){
    Cookies.remove(Properties.BATCH_ID_PROP, { path: '/' });
    Cookies.remove(Properties.DUMMY_RELOAD_PROP, { path: '/' });
    Cookies.remove(Properties.GRADE_PROP, { path: '/' });
    Cookies.remove(Properties.PROFILE_IMAGE_URL_PROP, { path: '/' });
    Cookies.remove(Properties.STUDENT_NAME_PROP, { path: '/' });
    Cookies.remove(Properties.STUDENT_ID_PROP, { path: '/' });
    Cookies.remove(Properties.ROUTE_ID_PROP, { path: '/' });
    Cookies.remove(Properties.USER_TYPE_PROP, { path: '/' });
    Cookies.remove(Properties.SESSION_TOKEN_PROP, { path: '/' });
     Cookies.remove(Properties.SCHOOL_ID_PROP, { path: '/' });

}
export const clearCookiesAndNavigate = () => {
    clearCookies();
    sessionStorage.removeItem(Properties.NAME_PROP, { path: '/' });
    window.location.href = Navigation.NAVIGATE_URL_GLOGIN;
};

export const clearCookiesAndNavigateforGlobalNetwork = (errorMssg,errorCode) => {
    clearCookies();
    sessionStorage.removeItem(Properties.NAME_PROP, { path: '/' });
    window.location.href = `/GlobalError?errorMssg=${errorMssg}&errorCode=${errorCode}`;
    
};

export const clearCookiesAndNavigateToExternalSiteHome = () => {
    clearCookies();
    window.location.href = '/';
};

export const handleKeyPress = (event) => {
    if (!/[0-9]/.test(event.key)) {
      event.preventDefault(); // Prevent non-numeric input
    }
  };

export function camelize(str) {
    //This function is used to join sentence and convert into camel-case ex: 'text1 text2' to text1Text2
    return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index) {
      return index === 0 ? word.toLowerCase() : word.toUpperCase();
    }).replace(/\s+/g, '');
  }

  export function split(str, splitBy) {
    const words = str.split(splitBy);
    return words
}

/*********************Req Operation******************************* */
export const fetchOperation = async (url,header) => {
    try {
        const response = await axios.get(url,header);
        return response.data;
    } catch (error) {
       return  ErrorFunction(ErrorConstants.GET,error)
    }
};

export const postOperation = async (url,dataJson,header) => {
    try {
        const response = await axios.post(url,dataJson,header);
        return response;
    } catch (error) {
       return  ErrorFunction(ErrorConstants.POST,error)
    }
};

export const putOperation = async (url,dataJson,header) => {
    try {
        const response = await axios.put(url,dataJson,header);
        return response;
    } catch (error) {
       return  ErrorFunction(ErrorConstants.PUT,error)
    }
};


export const getHeaders = (token,userId) => {
    if(token !=null){
        return {headers :{ 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}`, "userId" : userId }};
    }else{
        return {headers :{ 'Content-Type': 'application/json'}};
    }
 
}

export const getHeadersforFileUpload = (token,userId) => {
    if(token !=null){
        return {headers :{ 'Content-Type': 'multipart/form-data', 'Authorization': `Bearer ${token}`, "userId" : userId }};
    }else{
        return {headers :{ 'Content-Type': 'multipart/form-data'}};
    }
 
}
 
export const deleteOperation = async (url,header,confirmDelete) => {
    
    if (!confirmDelete) {
        return; 
    }

    try {
        const response = await axios.delete(url,header);
        return response.data;
    } catch (error) {
        return ErrorFunction(ErrorConstants.DELETE, error);
    }
};


export const handleEncode = (plainText) => {    
	try {     
		return  btoa(plainText); 
	} catch (error) { 
		console.error("Encoding failed:", error);   
	}  
};

/************** STandard Date Format (DD_MM_YYYY) ********************* */
export const format_DD_MM_YYYY_ForDatabase = (dob) => {
 const regex = /^\d{4}-\d{2}-\d{2}$/;
   if(regex.test(dob)){
     const [year, month, day] = dob.split('-');
    return `${day}-${month}-${year}`;
   }
   else{
    return dob;
   }
};
export const Dateformat_TO_YYYY_MM_DD = (dob) => {
const dd_mm_yyyy = /^\d{2}-\d{2}-\d{4}$/;
    if(dd_mm_yyyy.test(dob)){
    const [day, month, year] = dob.split('-');
    return `${year}-${month}-${day}`;
    }
    else{
     return dob;
    }       
}
/************************************************************************** */
export const dateFormat_YYYY_MM_DD = (date)=>{
    let newDate = new Date(date);
    const formatedDate = `${newDate.getFullYear()}-${newDate.getMonth() + 1}-${newDate.getDate()}`;
    // if(!isNaN(newDate)){
        return formatedDate; 
    // }else{
    //     return 'Enter valid Date.';
    // }
}

export const dateFormat_DD_MM_YYYY = (date)=>{
    let newDate = new Date(date);
    if(!isNaN(newDate)){
        const month = date.getMonth() + 1;
        const day = date.getDate();
        const formatedDate = `${day.toString().length===1?`0${day}`:day}-${month.toString().length===1?`0${month}`:month}-${date.getFullYear()}`;;
        return formatedDate; 
    }else{
        return 'Enter valid Date.';
    }
}

 export const formatDate = (dateStr) => {
        const date = new Date(dateStr);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${day}-${month}-${year}`;
    }
export const gradeOptions = grades.filter(grade => grade !== 'All Grades').map((grade, index) => (
    <option key={index} value={grade}>
      {grade}
    </option>
  ));
  // export const delay = ms => new Promise(resolve => setTimeout(resolve, ms));
  // await delay(10000);
  export const toPascalCase = (str) =>
    str
      .match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)
      .map((x) => x.charAt(0).toUpperCase() + x.slice(1).toLowerCase())
      .join("");



        export function getSubdomain(url) {
           
            try {
                // Create a URL object
                const parsedUrl = new URL(url);
                // Extract the hostname
                const hostname = parsedUrl.hostname;
                
                // Split the hostname into parts
                const parts = hostname.split('.');
        
                // Check if we have at least three parts (subdomain, domain, top-level domain)
                // console.log(parts, parts.length);
                if (parts.length < 3) {
                    return null; // No subdomain present
                }
        
                // Remove the last two parts (domain and TLD)
                const subdomainParts = parts.slice(0, -2);
        
                // Join the remaining parts to form the subdomain
                //return subdomainParts.join('.');
                return subdomainParts[0];
            } catch (e) {
                console.error('Invalid URL:', e);
                return null;
            }
        }

export function romanToNumber(romanChar){
    switch (romanChar) {
        case 'I':return 1;
        case 'II':return 2;
        case 'III':return 3;
        case 'IV':return 4;
        case 'V':return 5;
        case 'VI':return 6;
        case 'VII':return 7;
        case 'VIII':return 8;
        case 'IX':return 9;
        case 'X':return 10;
        case 'XI':return 11;
        case 'XII':return 12;
        default:console.error(`FunctionConstant :: romanToNumber(${romanChar}) : Invalid Roman Number.`);
    }
}

export function getDeviceId(payload){
    let deviceIdData = localStorage.getItem(GSystemConstants.DEVICE_ID_KEY) || "";
    if(deviceIdData){
       let decryptedDeviceIdData =  decryptData(GSystemConstants.DEVICE_ID_KEY,deviceIdData);
        let phoneNumber = decryptedDeviceIdData.split(":")[0];
        let pwd = decryptedDeviceIdData.split(":")[1];
        if(payload.phoneNo ===phoneNumber && payload.password===pwd){
            return true;
        }
        return false;
    }
    return false;
}
export function setCookiesToLocalStorateTemp(payload){
      localStorage.setItem(Properties.USER_TYPE_PROP,Cookies.get(Properties.USER_TYPE_PROP));
      localStorage.setItem(Properties.STUDENT_NAME_PROP,Cookies.get(Properties.STUDENT_NAME_PROP));
      localStorage.setItem(Properties.STUDENT_ID_PROP,Cookies.get(Properties.STUDENT_ID_PROP));
      localStorage.setItem(Properties.GRADE_PROP,Cookies.get(Properties.GRADE_PROP));
      localStorage.setItem(Properties.PROFILE_IMAGE_URL_PROP,Cookies.get(Properties.PROFILE_IMAGE_URL_PROP));
      localStorage.setItem(Properties.ROUTE_ID_PROP,Cookies.get(Properties.ROUTE_ID_PROP));
      localStorage.setItem(Properties.DUMMY_RELOAD_PROP,Cookies.get(Properties.DUMMY_RELOAD_PROP));
      localStorage.setItem(Properties.SCHOOL_ID_PROP,Cookies.get(Properties.SCHOOL_ID_PROP));
      localStorage.setItem(Properties.BATCH_ID_PROP,Cookies.get(Properties.BATCH_ID_PROP));
      localStorage.setItem(Properties.SESSION_TOKEN_PROP,Cookies.get(Properties.SESSION_TOKEN_PROP));
      let credentials = payload.phoneNo+":"+payload.password;
      localStorage.setItem(GSystemConstants.DEVICE_ID_KEY,encryptData(GSystemConstants.DEVICE_ID_KEY,credentials));
}
export function addCookies(response,payload){
    const { Student_Id,StudentName,Grade,Profile_url, UserType,routeId,batchId,SessionToken} = response.data;
    const expirationTime = null;
    const studentFirstName = StudentName.split(" ")[0];
    const isCookieEncryption = `${systemConfiguration.ENCRYPTION_COOCKIES_FLAG}`
    if (isCookieEncryption==='true') { 
      Cookies.set(Properties.USER_TYPE_PROP, UserType ? encryptData(Properties.USER_TYPE_PROP, UserType): "", { expires: expirationTime, path: '/' });
      Cookies.set(Properties.STUDENT_NAME_PROP, studentFirstName ?encryptData(Properties.STUDENT_NAME_PROP, studentFirstName): "", { expires: expirationTime, path: '/' });
      Cookies.set(Properties.STUDENT_ID_PROP, Student_Id?encryptData(Properties.STUDENT_ID_PROP, Student_Id): "", { expires: expirationTime, path: '/' });
      Cookies.set(Properties.GRADE_PROP, Grade?encryptData(Properties.GRADE_PROP, Grade): "", { expires: expirationTime, path: '/' });
      Cookies.set(Properties.PROFILE_IMAGE_URL_PROP, Profile_url? encryptData(Properties.PROFILE_IMAGE_URL_PROP, Profile_url) : "", { expires: expirationTime, path: '/' });
      Cookies.set(Properties.ROUTE_ID_PROP, routeId?encryptData(Properties.ROUTE_ID_PROP, routeId): "", { expires: expirationTime, path: '/' });
      Cookies.set(Properties.DUMMY_RELOAD_PROP,Properties.DUMMY_RELOAD_PROP , { expires: expirationTime, path: '/' });
      Cookies.set(Properties.SCHOOL_ID_PROP, encryptData(Properties.SCHOOL_ID_PROP,systemConfiguration.SCHOOL_ID, { expires: expirationTime, path: '/' }));
      Cookies.set(Properties.BATCH_ID_PROP, batchId?encryptData(Properties.BATCH_ID_PROP, batchId): "", { expires: expirationTime, path: '/' });
      Cookies.set(Properties.SESSION_TOKEN_PROP, SessionToken?encryptData(Properties.SESSION_TOKEN_PROP, SessionToken): "", { expires: expirationTime, path: '/' });
      setCookiesToLocalStorateTemp(payload);
}else {
    Cookies.set(Properties.USER_TYPE_PROP, UserType, { expires: expirationTime, path: '/' });
    Cookies.set(Properties.STUDENT_NAME_PROP, studentFirstName, { expires: expirationTime, path: '/' });
    Cookies.set(Properties.STUDENT_ID_PROP, Student_Id, { expires: expirationTime, path: '/' });
    Cookies.set(Properties.GRADE_PROP, Grade, { expires: expirationTime, path: '/' });
    Cookies.set(Properties.PROFILE_IMAGE_URL_PROP, Profile_url, { expires: expirationTime, path: '/' });
    Cookies.set(Properties.ROUTE_ID_PROP, routeId, { expires: expirationTime, path: '/' });
    Cookies.set(Properties.DUMMY_RELOAD_PROP, Properties.DUMMY_RELOAD_PROP, { expires: expirationTime, path: '/' });
    Cookies.set(Properties.SCHOOL_ID_PROP, systemConfiguration.SCHOOL_ID, { expires: expirationTime, path: '/' });
    Cookies.set(Properties.BATCH_ID_PROP, batchId, { expires: expirationTime, path: '/' });
    Cookies.set(Properties.SESSION_TOKEN_PROP, SessionToken, { expires: expirationTime, path: '/' });
    setCookiesToLocalStorateTemp(payload);
  }
}
export function addLocalStorageToCookies(){
   let UserType = localStorage.getItem(Properties.USER_TYPE_PROP);
   let studentFirstName = localStorage.getItem(Properties.STUDENT_NAME_PROP);
   let Student_Id = localStorage.getItem(Properties.STUDENT_ID_PROP);
   let Grade = localStorage.getItem(Properties.GRADE_PROP);
   let Profile_url = localStorage.getItem(Properties.PROFILE_IMAGE_URL_PROP);
   let routeId = localStorage.getItem(Properties.ROUTE_ID_PROP);
   let dummyReload = localStorage.getItem(Properties.DUMMY_RELOAD_PROP);
   let school_id = localStorage.getItem(Properties.SCHOOL_ID_PROP);
   let batchId = localStorage.getItem(Properties.BATCH_ID_PROP);
   let SessionToken = localStorage.getItem(Properties.SESSION_TOKEN_PROP);

    const expirationTime = null;
    Cookies.set(Properties.USER_TYPE_PROP, UserType ? UserType : "", { expires: expirationTime, path: '/' });
    Cookies.set(Properties.STUDENT_NAME_PROP, studentFirstName ? studentFirstName: "", { expires: expirationTime, path: '/' });
    Cookies.set(Properties.STUDENT_ID_PROP, Student_Id? Student_Id : "", { expires: expirationTime, path: '/' });
    Cookies.set(Properties.GRADE_PROP, Grade? Student_Id: "", { expires: expirationTime, path: '/' });
    Cookies.set(Properties.PROFILE_IMAGE_URL_PROP, Profile_url? Profile_url : "", { expires: expirationTime, path: '/' });
    Cookies.set(Properties.ROUTE_ID_PROP, routeId? routeId : "", { expires: expirationTime, path: '/' });
    Cookies.set(Properties.DUMMY_RELOAD_PROP,dummyReload , { expires: expirationTime, path: '/' });
    Cookies.set(Properties.SCHOOL_ID_PROP, school_id? school_id:"", { expires: expirationTime, path: '/' });
    Cookies.set(Properties.BATCH_ID_PROP, batchId? batchId : "", { expires: expirationTime, path: '/' });
    Cookies.set(Properties.SESSION_TOKEN_PROP, SessionToken? SessionToken : "", { expires: expirationTime, path: '/' });
}

export function reactSpinner(loading){
    {
        return loading && (
        <div >
            <Spinner animation="border" role="status" size="sm" />
            <span className="ms-2">Fetching records...</span>
        </div>
    )}
}

export function reactLoginSpinner(loading){
    {
        return loading && (
        <div >
            <Spinner animation="border" role="status" size="sm" />
            <span className="ms-2">Authenticating...</span>
        </div>
    )}
}

export function includeBootstrapCss(){
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = "https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css";
    link.id = "include-css-bootstrap";
    document.head.appendChild(link);
   return () => {
      document.head.removeChild(link);
    };

}

export function includeBundleBootstrapCss(){
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = "https://cdnjs.cloudflare.com/ajax/libs/animate.css/4.1.1/animate.min.css";
    link.id = "bundle-include-css-bootstrap";
    document.head.appendChild(link);
   return () => {
      document.head.removeChild(link);
    };

}

export function includeScripts(){
    let script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = "https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/js/bootstrap.bundle.min.js";
    document.head.appendChild(script);
    //script.onload = function() {
   // console.log(window.a)
   // }


}